import { isOfType } from '../../../../ts-utils';
const topLevelCommentStateTags = [
    'COMMENT_CREATE_PENDING',
    'COMMENT_CREATE_ERROR',
    'COMMENT_READY',
    'COMMENT_EDITING',
    'COMMENT_UPDATE_PENDING',
    'COMMENT_DELETE_PENDING',
    'COMMENT_DELETED',
    'COMMENT_LIVE_PENDING',
];
export const isCommentStateOUT = isOfType(topLevelCommentStateTags);
export const isCommentStateIN = isOfType(topLevelCommentStateTags);
const commentStateWithVotes = [
    'COMMENT_READY',
    'COMMENT_EDITING',
    'COMMENT_UPDATE_PENDING',
    'COMMENT_UPDATE_ERROR',
    'COMMENT_DELETE_PENDING',
];
export const canHaveVotes = isOfType(commentStateWithVotes);
//# sourceMappingURL=top-level-comment-types.js.map